<template>
  <div class="container-fluid">
    <dashboard-verify-email-alert
      v-if="$userIsUnverified"/>

     <div class="dashboard-block" v-if="$userIsPending">
      <div class="alert alert-info alert-icon">
        <i class="fa fa-info"></i>

        Your account is pending admin verification.
      </div>
    </div>

    <div v-if="$chatsModuleEnabled" class="dashboard-block">
      <h2 class="has-button">
        Active Chats
        &ndash;
        {{ lists.active_threads_count }}
      </h2>

      <div class="text-center alert alert-default" v-if="haveNoActiveThreads">
        There are no active chats
      </div>
      <ul v-else class="item-detail list-links">
        <user-dashboard-active-threads-list-item
          v-for="thread in activeThreads"
          :key="thread.id"
          :thread="thread"
          :booking="thread.booking"/>
      </ul>
      <div class="text-right">
        <router-link :to="{ name: 'threads.index' }" class="btn btn-info" style="letter-spacing: 2px">View All</router-link>
      </div>
    </div>

    <div class="dashboard-block">
      <h2 class="has-button">
        {{ $t('Booking Requests') }}
      </h2>

      <div class="text-center alert alert-default" v-if="haveNoBookingRequests">
        You have no {{ $t('booking requests') }} pending response.
      </div>
      <ul v-else class="item-detail list-links item-detail-price">
        <manager-dashboard-booking-requests-list-item
          v-for="booking in requests"
          :key="booking.id"
          :booking="booking"/>
      </ul>
      <div class="text-right">
        <router-link :to="{ name: 'requests.index' }" class="btn btn-info" style="letter-spacing: 2px">View All</router-link>
      </div>
    </div>

    <div class="dashboard-block">
      <h2 class="has-button">
        Booked Events
      </h2>

      <div class="text-center alert alert-default" v-if="haveNoBookings">
        You have no booked events.
      </div>
      <ul v-else class="item-detail list-links item-detail-price">
        <manager-dashboard-booking-list-item
          v-for="booking in bookings"
          :key="booking.id"
          :booking="booking"/>
      </ul>
      <div class="text-right">
        <router-link :to="{ name: 'bookings.index' }" class="btn btn-info" style="letter-spacing: 2px">View All</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DashboardVerifyEmailAlert from './DashboardVerifyEmailAlert'
import ManagerDashboardBookingRequestsListItem from './ManagerDashboardBookingRequestsListItem'
import ManagerDashboardBookingListItem from './ManagerDashboardBookingListItem'
import UserDashboardActiveThreadsListItem from './UserDashboardActiveThreadsListItem'
import Media from 'vue-media'

export default {
  components: {
    DashboardVerifyEmailAlert,
    ManagerDashboardBookingRequestsListItem,
    ManagerDashboardBookingListItem,
    UserDashboardActiveThreadsListItem,
    Media
  },

  computed: {
    ...mapState('dashboard', ['lists']),

    activeThreads () {
      return this.lists.active_threads || []
    },

    requests () {
      return this.lists.requests || []
    },

    bookings () {
      return this.lists.bookings || []
    },

    haveNoActiveThreads () {
      return this.lists.active_threads === undefined ||
        this.lists.active_threads.length === 0
    },

    haveNoBookingRequests () {
      return this.lists.requests === undefined ||
        this.lists.requests.length === 0
    },

    haveNoBookings () {
      return this.lists.bookings === undefined ||
        this.lists.bookings.length === 0
    }
  }
}
</script>
